import React, { useState } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import { useNavigate } from 'react-router-dom'
import icSend from '../../../../media/Generic/ic-send.svg'

const RecordsKeeperAIGenerator = () => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [aiTextInput, setAiTextInput] = useState('')
  const navigate = useNavigate()
  return (
    <div className='border bg-white rounded d-flex justify-content-between align-items-center p-2 mt-5'>
      <div className='d-flex flex-grow-1'>
        <img
          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-ai.svg')}
          alt='AI Icon'
          className='me-2'
        />
        <input
          type='text'
          placeholder={formatMessage({ id: 'Please enter prompt here... And find any records using AI' })}
          className='form-control w-100 border border-0'
          style={mode === 'dark' ? { background: '#323248' } : { background: '#ffffff' }}
          value={aiTextInput}
          onChange={(e) => setAiTextInput(e.target.value)}
        />
      </div>
      <button
        className='btn bg-primary text-white mt-md-0 d-flex align-items-center gap-2 p-3'
        onClick={() => {
          if (aiTextInput.length > 0) {
            navigate(`/query-and-prompt?textInput=${aiTextInput}`)
          }
        }}
      >
        <p className='mb-0 d-md-block d-none'>{formatMessage({ id: 'Find Records' })}</p>
        <img src={icSend} alt="" />
      </button>
    </div>
  )
}

export default RecordsKeeperAIGenerator
